/* Spazora: menú móvil, carrito lateral (AJAX API de Shopify) y selector de packs */
(function () {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const routes = window.spzRoutes || { root: '/', cartAdd: '/cart/add', cartChange: '/cart/change', cart: '/cart' };
  const esc = (s) => String(s ?? '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

  function money(cents) {
    const fmt = window.spzMoneyFormat || '{{amount_with_comma_separator}} €';
    const n = (cents / 100).toFixed(2);
    const [i, d] = n.split('.');
    const withDots = i.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    const withCommas = i.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) => {
      if (k === 'amount_with_comma_separator') return `${withDots},${d}`;
      if (k === 'amount_no_decimals_with_comma_separator') return withDots;
      if (k === 'amount_no_decimals') return withCommas;
      return `${withCommas}.${d}`;
    });
  }

  /* ---------- Menú móvil ---------- */
  const burger = $('[data-spz-burger]');
  const mobileMenu = $('[data-spz-mobile-menu]');
  if (burger && mobileMenu) {
    burger.addEventListener('click', () => {
      const open = mobileMenu.classList.toggle('open');
      burger.setAttribute('aria-expanded', open);
    });
  }

  /* ---------- Carrito lateral ---------- */
  const drawer = $('[data-spz-drawer]');
  const overlay = $('[data-spz-overlay]');
  function openCart() {
    if (!drawer) { location.href = routes.cart; return; }
    drawer.classList.add('open'); overlay.classList.add('open'); document.body.classList.add('spz-cart-open'); drawer.setAttribute('aria-hidden', 'false');
  }
  function closeCart() {
    drawer.classList.remove('open'); overlay.classList.remove('open'); document.body.classList.remove('spz-cart-open'); drawer.setAttribute('aria-hidden', 'true');
  }
  $$('[data-spz-cart-open]').forEach((b) => b.addEventListener('click', () => { refreshCart(); openCart(); }));
  $$('[data-spz-cart-close]').forEach((b) => b.addEventListener('click', closeCart));
  overlay && overlay.addEventListener('click', closeCart);
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && drawer && drawer.classList.contains('open')) closeCart(); });

  function renderCart(cart) {
    $$('[data-spz-cart-count]').forEach((el) => { el.textContent = cart.item_count; el.dataset.count = cart.item_count; });
    const sub = $('[data-spz-subtotal]'); if (sub) sub.textContent = money(cart.total_price);
    const body = $('[data-spz-cart-body]'); if (!body) return;
    const checkout = $('[data-spz-checkout]'); if (checkout) checkout.disabled = cart.item_count === 0;
    if (!cart.items.length) { body.innerHTML = '<p class="spz-empty">Tu carrito está vacío.</p>'; return; }
    body.innerHTML = cart.items.map((it) => {
      const img = it.image ? `<img src="${esc(it.image)}${it.image.includes('?') ? '&' : '?'}width=120" alt="${esc(it.product_title)}" loading="lazy">` : '';
      const opts = it.variant_title && it.variant_title !== 'Default Title' ? `${esc(it.variant_title)} · ` : '';
      return `<div class="spz-line" data-key="${esc(it.key)}">
        <div class="th">${img}</div>
        <div><a href="${esc(it.url)}" style="text-decoration:none"><b>${esc(it.product_title)}</b></a><br>
          <small>${opts}${money(it.final_price)} / ud</small>
          <div class="ctl"><button type="button" data-q="-1" aria-label="Menos">−</button><span>${it.quantity}</span><button type="button" data-q="1" aria-label="Más">+</button><button type="button" class="rm" data-q="rm">Eliminar</button></div>
        </div>
        <b>${money(it.final_line_price)}</b></div>`;
    }).join('');
    $$('.spz-line', body).forEach((line) => {
      const key = line.dataset.key;
      const item = cart.items.find((i) => i.key === key);
      $$('button', line).forEach((b) => b.addEventListener('click', () => {
        const q = b.dataset.q === 'rm' ? 0 : Math.max(0, item.quantity + Number(b.dataset.q));
        changeLine(key, q);
      }));
    });
  }
  async function refreshCart() {
    try { const r = await fetch(routes.root + 'cart.js', { headers: { Accept: 'application/json' } }); renderCart(await r.json()); } catch (e) {}
  }
  async function changeLine(key, quantity) {
    const r = await fetch(routes.cartChange + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity }) });
    if (r.ok) renderCart(await r.json());
  }
  async function addToCart(id, quantity) {
    const r = await fetch(routes.cartAdd + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id, quantity }] }) });
    const data = await r.json();
    if (!r.ok) throw new Error(data.description || data.message || 'No se pudo añadir al carrito');
    await refreshCart(); openCart();
  }
  if (drawer) refreshCart();
  window.spzCart = { open: openCart, refresh: refreshCart, add: addToCart };

  /* ---------- Ficha de producto ---------- */
  const root = $('[data-spz-product]');
  if (!root) return;
  const data = JSON.parse($('[data-spz-product-json]', root).textContent);
  const variants = data.variants;
  const packIdx = data.packIndex, colorIdx = data.colorIndex;
  let state = { pack: null, color: null, qty: 1 };
  const current = variants.find((v) => v.id === data.selectedId) || variants.find((v) => v.available) || variants[0];
  state.pack = packIdx >= 0 ? current.options[packIdx] : null;
  state.color = colorIdx >= 0 ? current.options[colorIdx] : null;
  if (!data.hasVariantParam && data.defaultPack && packIdx >= 0 && data.packs.some((p) => p.value === data.defaultPack)) state.pack = data.defaultPack;
  const urlPack = new URLSearchParams(location.search).get('pack');
  if (urlPack && packIdx >= 0) {
    const match = data.packs.find((p) => p.value.toLowerCase() === urlPack.toLowerCase() || p.value.replace(/\D/g, '') === urlPack.replace(/\D/g, ''));
    if (match) state.pack = match.value;
  }

  function findVariant() {
    return variants.find((v) =>
      (packIdx < 0 || v.options[packIdx] === state.pack) && (colorIdx < 0 || v.options[colorIdx] === state.color)
    ) || null;
  }
  const mainImg = $('[data-spz-main] img', root);
  const thumbs = $$('[data-spz-thumb]', root);
  function showMedia(src, alt) { if (mainImg && src) { mainImg.src = src; mainImg.alt = alt || ''; mainImg.removeAttribute('srcset'); } }
  thumbs.forEach((t) => t.addEventListener('click', () => {
    thumbs.forEach((x) => x.classList.toggle('active', x === t));
    showMedia(t.dataset.full, t.dataset.alt);
  }));

  function variantForPack(pack) {
    return variants.find((v) => v.options[packIdx] === pack && (colorIdx < 0 || v.options[colorIdx] === state.color))
      || variants.find((v) => v.options[packIdx] === pack);
  }
  function update() {
    const v = findVariant();
    $$('[data-spz-pack]', root).forEach((el) => {
      const pv = variantForPack(el.dataset.spzPack);
      const sel = el.dataset.spzPack === state.pack;
      el.classList.toggle('sel', sel);
      el.classList.toggle('soldout', !pv || !pv.available);
      const input = $('input', el); if (input) input.checked = sel;
      if (pv) {
        $('[data-price]', el).textContent = money(pv.price);
        const c = $('[data-compare]', el);
        if (c) { const on = pv.compare_at_price > pv.price; c.hidden = !on; c.textContent = on ? money(pv.compare_at_price) : ''; }
        const units = Number(el.dataset.units || 0);
        const u = $('[data-unit]', el); if (u) u.textContent = units ? `${money(Math.round(pv.price / units))} / ud` : '';
      }
    });
    $$('[data-spz-color]', root).forEach((b) => b.classList.toggle('sel', b.dataset.spzColor === state.color));
    const cn = $('[data-spz-color-name]', root); if (cn) cn.textContent = state.color || '';
    const btns = $$('[data-spz-add]');
    const err = $('[data-spz-error]', root);
    if (err) err.textContent = '';
    btns.forEach((b) => {
      b.disabled = !v || !v.available;
      b.textContent = !v ? 'No disponible' : v.available ? b.dataset.label : 'Agotado';
    });
    const sp = $('[data-spz-sticky-price]'); if (sp && v) sp.textContent = money(v.price);
    const sn = $('[data-spz-sticky-name]'); if (sn) sn.textContent = [state.pack, state.color].filter(Boolean).join(' · ');
    if (v) {
      const idInput = $('[name="id"]', root); if (idInput) idInput.value = v.id;
      const url = new URL(location.href); url.searchParams.set('variant', v.id); url.searchParams.delete('pack');
      history.replaceState(null, '', url);
    }
  }
  $$('[data-spz-pack] input', root).forEach((r) => r.addEventListener('change', () => { state.pack = r.value; update(); }));
  $$('[data-spz-color]', root).forEach((b) => b.addEventListener('click', () => {
    state.color = b.dataset.spzColor; update();
    const v = findVariant(); if (v && v.image) { showMedia(v.image, state.color); thumbs.forEach((t) => t.classList.remove('active')); }
  }));
  const qv = $('[data-spz-qty]', root);
  $('[data-spz-minus]', root)?.addEventListener('click', () => { state.qty = Math.max(1, state.qty - 1); qv.textContent = state.qty; });
  $('[data-spz-plus]', root)?.addEventListener('click', () => { state.qty = Math.min(20, state.qty + 1); qv.textContent = state.qty; });
  $$('[data-spz-add]').forEach((b) => {
    b.dataset.label = b.textContent.trim();
    b.addEventListener('click', async (e) => {
      e.preventDefault();
      const v = findVariant(); if (!v) return;
      b.disabled = true;
      try { await addToCart(v.id, state.qty); }
      catch (err) { const el = $('[data-spz-error]', root); if (el) el.textContent = err.message; }
      finally { b.disabled = !v.available; }
    });
  });

  /* Fecha estimada de entrega */
  const note = $('[data-spz-delivery]', root);
  if (note) {
    const min = Number(note.dataset.min || 0), max = Number(note.dataset.max || 0);
    if (min && max) {
      const addBiz = (d, n) => { d = new Date(d); while (n > 0) { d.setDate(d.getDate() + 1); if (d.getDay() % 6) n--; } return d; };
      const fmt = (d) => d.toLocaleDateString('es-ES', { day: 'numeric', month: 'long' });
      note.textContent = `Entrega estimada entre el ${fmt(addBiz(new Date(), min))} y el ${fmt(addBiz(new Date(), max))}${note.dataset.suffix ? ' · ' + note.dataset.suffix : ''}`;
    }
  }
  update();
})();
